export default __webpack_public_path__ + "static/media/bekoBayiLogo.a360ba80.jpg";